<template>
  <b-card
    no-body
    class="overflow-hidden"
  >
    <b-table-simple
      bordered
      hover
    >
      <b-thead>
        <b-tr>
          <b-th class="text-center width-100">
            <FeatherIcon icon="SaveIcon" />
          </b-th>
          <b-th>Taksit</b-th>
          <b-th>Vade Ay</b-th>
          <b-th>Vade Farkı</b-th>
          <b-th class="text-center width-100">
            <FeatherIcon icon="EditIcon" />
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(item,key) in dataList"
          :key="item.id"
        >
          <b-td class="text-center text-nowrap px-1">
            <b-button
              variant="flat-success"
              size="sm"
              pill
              block
              @click="saveData(item)"
            >
              <FeatherIcon icon="CheckCircleIcon" />
              Güncelle
            </b-button>
          </b-td>
          <b-td class="px-1">
            <b-form-input
              v-model="item.title"
              :disabled="key === 0"
              placeholder="Taksit Sayısı"
            />
          </b-td>
          <b-td class="px-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                Ay
              </b-input-group-prepend>
              <cleave
                v-model="item.installment"
                class="form-control"
                :disabled="key === 0"
                :raw="true"
                :options="options.number"
                placeholder="Taksit Sayısı"
              />
            </b-input-group>
          </b-td>
          <b-td class="px-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                %
              </b-input-group-prepend>
              <cleave
                v-model="item.rate"
                class="form-control"
                :disabled="key === 0"
                :raw="true"
                :options="options.number"
                placeholder="Vade Farkı"
              />
            </b-input-group>
          </b-td>
          <b-td class="text-center text-nowrap px-1">
            <b-button
              variant="flat-danger"
              size="sm"
              pill
              block
              @click="removeData(item.id)"
            >
              <FeatherIcon icon="XCircleIcon" />
              Sil
            </b-button>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td class="text-center text-nowrap px-1">
            <b-button
              variant="primary"
              size="sm"
              pill
              block
              @click="saveData(dataItem)"
            >
              <FeatherIcon icon="CheckCircleIcon" />
              Taksit Ekle
            </b-button>
          </b-td>
          <b-td class="px-1">
            <b-form-input
              v-model="dataItem.title"
              placeholder="Taksit Sayısı"
            />
          </b-td>
          <b-td class="px-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                Ay
              </b-input-group-prepend>
              <cleave
                v-model="dataItem.installment"
                class="form-control"
                :raw="true"
                :options="options.number"
                placeholder="Taksit Sayısı"
              />
            </b-input-group>
          </b-td>
          <b-td class="px-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                %
              </b-input-group-prepend>
              <cleave
                v-model="dataItem.rate"
                class="form-control"
                :raw="true"
                :options="options.number"
                placeholder="Vade Farkı"
              />
            </b-input-group>
          </b-td>
          <b-td />
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-card>
</template>
<script>
import {
  BButton,
  BCard,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BTableSimple,
  BTbody,
  BTd,
  BTh,
  BThead,
  BTr,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Installments',
  components: {
    BCard,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    Cleave,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ',',
        },
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['posInstallments/dataList']
    },
    dataItem() {
      return this.$store.getters['posInstallments/dataItem']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('posInstallments/getDataList', {
        where: {
          'pos_installments.id_pos_configs': this.$route.params.id,
          'pos_installments.is_private': '0',
        },
      })
    },
    saveData(item) {
      const params = item
      params.id_pos_configs = this.$route.params.id
      this.$store.dispatch('posInstallments/saveData', params)
        .then(response => {
          if (response) {
            this.getDataList()
            this.$store.commit('posInstallments/RESET_DATA_ITEM')
          }
        })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('posInstallments/removeData', id)
            .then(response => {
              if (response) {
                this.getDataList()
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
